import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { InfoIcon } from 'foundations-assets';
import { hasLimit, isCapacityFull } from '../../utils/capacityUtils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Small } from 'foundations-components/transitional/components/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TotalCapacityStatus = ({
  capacity
}) => {
  return /*#__PURE__*/_jsx(Flex, {
    paddingInlineStart: "200",
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "routing-ui.agent-status.statusPopover.header.limitTickets",
        options: {
          capacityLoad: capacity.capacityLoad,
          capacityLimit: capacity.capacityLimit
        }
      }),
      children: /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "100",
          children: [/*#__PURE__*/_jsx(InfoIcon, {
            alignWithText: true
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "routing-ui.agent-status.capacityLimits.fullCapacity"
          })]
        })
      })
    })
  });
};
TotalCapacityStatus.displayName = 'TotalCapacityStatus';
const CategoryCapacityStatus = ({
  capacity
}) => {
  const {
    CALLING,
    REAL_TIME_MESSAGING,
    ASYNC_COMMUNICATION
  } = capacity;
  return /*#__PURE__*/_jsx(Flex, {
    paddingInlineStart: "200",
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        children: [hasLimit(CALLING) && /*#__PURE__*/_jsx(FormattedMessage, {
          message: "routing-ui.agent-status.statusPopover.header.limitCall",
          options: CALLING
        }), hasLimit(REAL_TIME_MESSAGING) && /*#__PURE__*/_jsx(FormattedMessage, {
          message: "routing-ui.agent-status.statusPopover.header.limitMessaging",
          options: REAL_TIME_MESSAGING
        }), hasLimit(ASYNC_COMMUNICATION) && /*#__PURE__*/_jsx(FormattedMessage, {
          message: "routing-ui.agent-status.statusPopover.header.limitOther",
          options: ASYNC_COMMUNICATION
        })]
      }),
      children: /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "100",
          children: [/*#__PURE__*/_jsx(InfoIcon, {
            alignWithText: true
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "routing-ui.agent-status.capacityLimits.fullCapacityForMessaging"
          })]
        })
      })
    })
  });
};
CategoryCapacityStatus.displayName = 'CategoryCapacityStatus';
export const CapacityStatus = ({
  userCapacity
}) => {
  const {
    type,
    capacity
  } = userCapacity;
  if (type === 'TOTAL' && isCapacityFull(capacity)) {
    return /*#__PURE__*/_jsx(TotalCapacityStatus, {
      capacity: capacity
    });
  } else if (type === 'BY_CAPACITY_CATEGORY' && isCapacityFull(capacity.REAL_TIME_MESSAGING)) {
    return /*#__PURE__*/_jsx(CategoryCapacityStatus, {
      capacity: capacity
    });
  }
  return null;
};
CapacityStatus.displayName = 'CapacityStatus';